<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  interface Props {
    name?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { name = 'Credential', onclick }: Props = $props();
</script>

<button data-cy={`backTo${name}`} type="button" class="back-btn" {onclick}>
  <div class="icon default">
    <Icon value="icon-arrow-left" />
  </div>
  <div class="icon hover">
    <Icon value="icon-arrow-left active" />
  </div>
  <div class="text">Back</div>
</button>

<style>
  .back-btn,
  .back-btn .icon {
    display: flex;
    align-items: center;
  }
  .back-btn {
    width: 100%;
    height: 32px;
    color: var(--grey-medium);
  }
  .back-btn .icon {
    margin-right: 8px;
  }
  .back-btn .icon.hover {
    display: none;
  }
  .back-btn:hover {
    color: var(--blue);
  }
  .back-btn:hover .icon.default {
    display: none;
  }
  .back-btn:hover .icon.hover {
    display: flex;
  }
</style>
